export default "__VITE_ASSET__14839d06__"